<form
  class="form"
  autocomplete="off"
  [formGroup]="promotionsForm"
  (submit)="submit()"
>
  <h2 mat-dialog-title *ngIf="verTitulo">{{titulo}}</h2>
  <mat-dialog-content style="background-image: url({{imgUrl}}); background-size: cover; background-position: center;">
    
    <div class="col-12 mb-3" *ngIf="verPregunta">
      <span class="mb-2 colorLetra">{{pregunta}}</span>
      <div class="musicGrid">
        <mat-checkbox *ngFor="let respuesta of respuestas" class="d-block colorLetra" (change)="guardarRespuestas(respuesta.idRespuesta)">{{respuesta.respuesta}}</mat-checkbox>
      </div>       
    </div>
    
    <div class="row">
      <mat-form-field appearance="outline" class="col-12">
        <mat-label class="colorLetra">{{ "full_name" | translate }} </mat-label>
        <input
          class="colorLetra"
          appInputRestriction="name"
          type="text"
          matInput
          placeholder="{{ 'enter_your_name' | translate }}"
          formControlName="nombre"
          [maxlength]="50"
        />

        <mat-error *ngIf="promotionsForm.get('nombre')!.invalid">
          {{ "invalid_name" | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="outline" class="col-12">
        <mat-label class="colorLetra">{{ "Whatsapp" | translate }} </mat-label>
        <input
          type="text"
          class="colorLetra"
          matInput
          placeholder="{{ 'enter_your_phone_number_promo' | translate }}"
          formControlName="telefono"
          prefix="+52 "
          mask="(000) 000 0000"
        />
        <mat-error *ngIf="promotionsForm.get('telefono')!.invalid">
          {{ "invalid_phone_number" | translate }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-12">
        <mat-label class="colorLetra">{{ "email_address" | translate }}</mat-label>
        <input
          appInputRestriction="email"
          type="text"
          class="colorLetra"
          matInput
          placeholder="{{ 'enter_your_email_address' | translate }}"
          formControlName="email"
          [maxlength]="50"
        />
        <mat-error *ngIf="promotionsForm.get('email')!.invalid">
          {{ "invalid_email_address" | translate }}
        </mat-error>
      </mat-form-field>

      
      <div class="col-12" *ngIf="instagramUrl">
        <h6 class="colorLetra">{{ "our_instagram" | translate }}</h6>
        <a target="_blank" [href]="instagramUrl">
          <img
            src="./assets/icons/instagramLogo.png"
            alt="instagram"
            width="50"
            height="50"
        /></a>
      </div>

      <!-- <div class="col-12">
        <mat-checkbox formControlName="mostrar">Dejar de mostrar</mat-checkbox>
      </div> -->
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-flat-button type="button" mat-dialog-close>
      {{ "close" | translate }}
    </button>
    <button mat-flat-button color="primary" type="submit">
      {{ "send" | translate }}
    </button>
  </mat-dialog-actions>
</form>
